import React, { useEffect, useRef, useState } from "react";
import { Html5Qrcode } from "html5-qrcode";
import { Camera, X } from "lucide-react";
import { Modal } from "@/components/common";

const REGION_ID = "barcode-scan-region";

// Modal kamera untuk scan barcode/QR di Web. Juga menerima input scanner USB/HID (ketik + Enter).
export default function BarcodeScanner({ open, onClose, onScanned, title = "Scan Barcode" }) {
  const scannerRef = useRef(null);
  const lockRef = useRef(false);
  const [error, setError] = useState("");
  const [manual, setManual] = useState("");

  useEffect(() => {
    if (!open) return undefined;
    lockRef.current = false;
    setError("");
    let stopped = false;
    const scanner = new Html5Qrcode(REGION_ID, { verbose: false });
    scannerRef.current = scanner;

    const handle = (decoded) => {
      if (lockRef.current || !decoded) return;
      lockRef.current = true;
      onScanned(String(decoded).trim());
      onClose();
    };

    scanner
      .start({ facingMode: "environment" }, { fps: 10, qrbox: { width: 260, height: 160 } }, handle, () => {})
      .catch(() => { if (!stopped) setError("Tidak bisa mengakses kamera. Gunakan scanner USB/HID atau ketik kode di bawah."); });

    return () => {
      stopped = true;
      const sc = scannerRef.current;
      if (sc) {
        sc.stop().then(() => sc.clear()).catch(() => {});
        scannerRef.current = null;
      }
    };
  }, [open]);

  const submitManual = () => {
    const v = manual.trim();
    if (!v) return;
    setManual("");
    onScanned(v);
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose} title={title} maxWidth="max-w-md">
      <div className="space-y-3">
        <div id={REGION_ID} data-testid="barcode-scan-region" className="w-full rounded-xl overflow-hidden bg-slate-900 min-h-[220px]" />
        {error ? <p className="text-sm text-amber-600 flex items-center gap-1.5"><Camera size={14} /> {error}</p>
          : <p className="text-xs text-slate-400 text-center">Arahkan kamera ke barcode · Code 128 / EAN / UPC / QR. Scanner USB/HID: fokuskan kolom lalu scan.</p>}
        <div className="flex items-center gap-2">
          <input
            autoFocus
            value={manual}
            onChange={(e) => setManual(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter") submitManual(); }}
            placeholder="Scan / ketik kode lalu Enter"
            data-testid="barcode-manual-input"
            className="flex-1 h-10 px-3 rounded-xl border border-slate-300 outline-none focus:border-primary"
          />
          <button onClick={submitManual} data-testid="barcode-manual-submit" className="h-10 px-4 rounded-xl bg-primary text-white text-sm font-medium">OK</button>
          <button onClick={onClose} className="h-10 w-10 rounded-xl border border-slate-200 flex items-center justify-center text-slate-500" data-testid="barcode-scan-close"><X size={16} /></button>
        </div>
      </div>
    </Modal>
  );
}
